import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';
import { surfaceM } from 'web-ui-kit/colors';
import CloseIcon from 'web-ui-kit/assets/CloseIcon';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject;

var SIZE_VARIANTS = {
  "default": {
    width: '24',
    height: '24'
  },
  large: {
    width: '36',
    height: '36'
  }
};

function DefaultNavIcon(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? '' : _ref$variant,
      _ref$sizeVariant = _ref.sizeVariant,
      sizeVariant = _ref$sizeVariant === void 0 ? '' : _ref$sizeVariant;
  var calculatedSize = SIZE_VARIANTS[sizeVariant];
  return (
    /*#__PURE__*/
    React.createElement(Svg, {
      width: calculatedSize.width,
      height: calculatedSize.height,
      viewBox: "0 0 24 24",
      fill: "none",
      variant: variant,
      xmlns: "http://www.w3.org/2000/svg"
    },
    /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16 6.87054L14.6069 5.5L8 12L14.6069 18.5L16 17.1295L10.7862 12L16 6.87054Z",
      fill: "#41434A"
    }))
  );
}

DefaultNavIcon.propTypes = {
  /**
  * The directional variant on the svg
  * One of:
  */
  variant: PropTypes.oneOf(['back', 'forward']),

  /**
   * The size variant on the svg
   * One of:
   * */
  sizeVariant: PropTypes.oneOf(['default', 'large'])
};
var Svg = styled.svg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), function (p) {
  return p.variant === 'forward' && "\n    transform: rotateZ(180deg);\n  ";
});

var _templateObject$1, _templateObject2, _templateObject3;

var NAV_TYPE_ICONS = {
  directional: DefaultNavIcon,
  close: CloseIcon
};
var CLOSE_ICON_SIZES = {
  "default": '32',
  large: '32'
};

var TYPE_ICON_PROPS = function TYPE_ICON_PROPS(_ref) {
  var variant = _ref.variant,
      sizeVariant = _ref.sizeVariant;
  return {
    directional: {
      variant: variant,
      sizeVariant: sizeVariant
    },
    close: {
      size: CLOSE_ICON_SIZES[sizeVariant]
    }
  };
};
/**
 * Buttons to indicate forward and backward navigation.
 */


function NavButton(_ref2) {
  var _ref2$ariaLabel = _ref2.ariaLabel,
      ariaLabel = _ref2$ariaLabel === void 0 ? '' : _ref2$ariaLabel,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      _ref2$onClick = _ref2.onClick,
      onClick = _ref2$onClick === void 0 ? function () {} : _ref2$onClick,
      _ref2$type = _ref2.type,
      type = _ref2$type === void 0 ? 'directional' : _ref2$type,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'back' : _ref2$variant,
      _ref2$sizeVariant = _ref2.sizeVariant,
      sizeVariant = _ref2$sizeVariant === void 0 ? 'default' : _ref2$sizeVariant;
  var Icon = NAV_TYPE_ICONS[type];
  var iconProps = TYPE_ICON_PROPS({
    variant: variant,
    sizeVariant: sizeVariant
  })[type];
  return (
    /*#__PURE__*/
    React.createElement(Button, {
      "aria-label": ariaLabel || "navigate ".concat(variant),
      className: className,
      onClick: onClick,
      variant: variant,
      sizeVariant: sizeVariant
    },
    /*#__PURE__*/
    React.createElement(Icon, iconProps))
  );
}

NavButton.propTypes = {
  /** Allows specifying an accessibility label.
   * Defaults to: `navigate ${variant}`
  */
  ariaLabel: PropTypes.string,

  /** Allows extending styles with styled(NavButton) constructor */
  className: PropTypes.string,

  /** Callback fired when the button is clicked */
  onClick: PropTypes.func,

  /** The type of navigation to display */
  type: PropTypes.oneOf(['directional', 'close']),

  /** The button variant.
   * One of:
   */
  variant: PropTypes.oneOf(['back', 'forward']),

  /**
   * The sizing variant
   * One of:
   */
  sizeVariant: PropTypes.oneOf(['default', 'large'])
};
var ButtonSizeVariants = {
  "default": css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    height: 2rem;\n    width: 2rem;\n  "]))),
  large: css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    height: 3rem;\n    width: 3rem;\n  "])))
};
var Button = styled.button(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", "\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  appearance: none;\n  background-color: ", ";\n  border: none;\n  border-radius: 50%;\n  box-shadow: 0px 2px 4px rgba(65, 67, 74, 0.15);\n  cursor: pointer;\n  outline: none;\n"])), function (_ref3) {
  var sizeVariant = _ref3.sizeVariant;
  return ButtonSizeVariants[sizeVariant];
}, surfaceM);
export default NavButton;